<template>
<nav id="topnav" role="navigation">
  <ul>
    <li class="calendar" :class="{active: parent=='calendar'}"><router-link to="/calendar">Calendar</router-link></li>
    <li class="daily" :class="{active: parent=='daily'}"><router-link to="/daily">Daily</router-link>
    <ul><li><router-link to="/daily/list">Manage Daily Items</router-link></li></ul>
    </li>
    <li class="goals" :class="{active: parent=='goals'}"><router-link to="/goals">Goals</router-link>
      <ul>
        <li class="goals-list"><router-link to="/goals/list">Manage Goals</router-link></li>
        <li class="business-goals"><router-link to="/goals/category/business">Business & Career</router-link></li>
        <li class="education-goals"><router-link to="/goals/category/education">Intellectual Development</router-link></li>
        <li class="family-goals"><router-link to="/goals/category/family">Family & Relationships</router-link></li>
        <li class="financial-goals"><router-link to="/goals/category/financial">Money & Finances</router-link></li>
        <li class="health-goals"><router-link to="/goals/category/health">Health & Fitness</router-link></li>
        <li class="social-goals"><router-link to="/goals/category/social">Social Life: Friend & Fun</router-link></li>
        <li class="spiritual-goals"><router-link to="/goals/category/spiritual">Spiritual: Beliefs & Values</router-link></li>
<!--
<li class="achieved-goals"><router-link to="/goals/achieved/">Achieved Goals</router-link></li>
-->
      </ul>
    </li>
    <li class="targets" :class="{active: parent=='targets'}"><router-link to="/targets">Targets</router-link>
      <ul>
        <li class="weekly-targets"><router-link to="/targets/list/weekly">Weekly Targets</router-link></li>
        <li class="monthly-targets"><router-link to="/targets/list/monthly">Monthly Targets</router-link></li>
        <li class="quarterly-targets"><router-link to="/targets/list/quarterly">Quarterly Targets</router-link></li>
      </ul>
    </li>
    <li class="wins" :class="{active: parent=='wins'}"><router-link to="/wins">Wins</router-link>
      <ul>
        <li class="wins-list"><router-link to="/wins/list/">Manage Wins</router-link></li>
      </ul>
    </li>
  </ul>
</nav>
  
</template>
<script>
export default {
  computed:{
    parent(){
      const regex=/([^/]+)/ig
      const matches=this.$route.path.match(regex);
      const parent=(matches && matches.length>0)? matches[0]:'';

      return parent;
    },
  }
}
</script>

